import { Directive } from "@app/components/directive";
import * as angular from "angular";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * KbScope
 *
 * Allows you to create a new prototypically inherited scope on an element.  Consider this example:
 * <div kb-scope="item: _selectedItem">
 *   <input ng-model="item.value"/>
 * </div>
 *
 * kbScope will put everything inside of the div into a new scope with the item property set on it
 * It accomplishes this by using transclusion
 */
@NgComponent({
    token: Token.KbScope,
    dependencies: [
    ]
})
export class KbScope extends Directive {
    constructor() {
        super();

        this.restrict = "A";
        this.scope = false;
        this.priority = 1000; // make sure it runs first
        this.transclude = "element";

        this.link = (scope, element: JQuery, atts: any, ctrl, $transclude) => {
            let childScope = scope.$new();
            scope.$watch("{" + atts.kbScope + "}", data => {
                angular.extend(childScope, data);
            }, true);

            $transclude(childScope, clone => {
                element.after(clone);
            });

            scope.$on("$destroy", () => {
                if (childScope) childScope.$destroy();
            });
        };
    }
}
